import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { clearBuyerAuth } from "store";
import CustomSideBar from "../shadcn/components/custom/CustomSideBar";
import { SidebarInset, SidebarProvider } from "../shadcn/components/ui/sidebar";
import HomeIcon from "../icons/HomeIcon";
import LoginSvg from "../icons/LoginSvg";
import UserIcon from "../icons/UserIcon";
import EventIcon from "../icons/EventIcon";
import CalendarIcon from "../icons/CalendarIcon";
import AuctionEvents from "../icons/Sidebar/AuctionEvents";
import DashboardHeader from "../components/seller/header/DashboardHeader";
import LogoSvg from "../icons/LogoSvg";

interface BuyerDashboardLayoutProps {
  children: React.ReactNode;
}

const BUYER_TABS = [
  {
    tabId: "home",
    text: "Home",
    href: "/",
    icon: <HomeIcon className="w-5 h-5" />,
  },
  {
    tabId: "assets",
    text: "Invited Assets",
    href: "/assets",
    icon: <CalendarIcon className="w-5 h-5" />,
  },
  {
    tabId: "bidding-offers",
    text: "Bidding Offers",
    href: "/bidding-offers",
    icon: <EventIcon className="w-6 h-6" />,
  },
  {
    tabId: "auction-events",
    text: "Swiss Challenge",
    href: "/auction-events",
    icon: <AuctionEvents className="w-6 h-6" />,
  },
  {
    tabId: "profile",
    text: "Profile",
    href: "/profile",
    icon: <UserIcon width={28} height={28} />,
  },
];

export default function BuyerDashboardLayout({
  children,
}: BuyerDashboardLayoutProps) {
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useSelector((state: any) => state.buyerAuth);
  const [currentActiveTab, setCurrentActiveTab] = useState<string>("home");

  useEffect(() => {
    const tab = BUYER_TABS.find(
      (t) =>
        t.href === router.pathname || router.pathname.startsWith(t.href + "/"),
    );
    if (tab) setCurrentActiveTab(tab.tabId);
  }, [router.pathname]);

  const tabClickHandler = (tab: { tabId: string; href: string }) => {
    setCurrentActiveTab(tab.tabId);
    router.push(tab.href);
  };

  const logoutHandler = () => {
    dispatch(clearBuyerAuth());
    router.replace("/login");
  };

  return (
    <div className="max-h-screen max-w-full bg-white dark:bg-gray-900">
      <SidebarProvider>
        <CustomSideBar
          tabs={BUYER_TABS}
          currentActiveTabId={currentActiveTab}
          tabOnClickHandler={(t) =>
            tabClickHandler({
              ...t,
              href:
                BUYER_TABS.find((x) => x.tabId === t.tabId)?.href ?? "/buyer",
            })
          }
          logo={<LogoSvg />}
          footer={
            <div
              className="flex items-center text-sm font-openSans gap-1 cursor-pointer"
              onClick={logoutHandler}
            >
              <LoginSvg height="40" width="40" bg_color="bg-transparent" />
              <div className="text-brand-textGrey hover:text-brand-textBlack">
                Logout
              </div>
            </div>
          }
        />
        <SidebarInset className="bg-[#F8F8F8]">
          <DashboardHeader
            userNameLabel={user?.profile?.bio?.full_name || "User"}
            userEmailLabel={
              user?.attributes?.find((attr: any) => attr.type === "email")
                ?.value || "user@example.com"
            }
          />
          <div className="flex flex-1 flex-col gap-4 overflow-scroll">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
